var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0232 13.8472L18.5921 17.4161L17.4136 18.5946L13.8447 15.0257C12.5615 16.0523 10.9341 16.6665 9.16406 16.6665C5.02406 16.6665 1.66406 13.3065 1.66406 9.1665C1.66406 5.0265 5.02406 1.6665 9.16406 1.6665C13.3041 1.6665 16.6641 5.0265 16.6641 9.1665C16.6641 10.9365 16.0499 12.5639 15.0232 13.8472ZM13.3513 13.2288C14.3703 12.1787 14.9974 10.7462 14.9974 9.1665C14.9974 5.94359 12.387 3.33317 9.16406 3.33317C5.94115 3.33317 3.33073 5.94359 3.33073 9.1665C3.33073 12.3894 5.94115 14.9998 9.16406 14.9998C10.7437 14.9998 12.1762 14.3728 13.2264 13.3538L13.3513 13.2288Z",
    fill: "white"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/SearchIcon.801b8e0b7c5812018571ee1aca629d0a.svg";
export { ForwardRef as ReactComponent };